import { Component, ElementRef, ViewChild } from '@angular/core';
import { OperationService } from 'src/app/shared/service/operation/operation.service';
import { ParameterService } from 'src/app/shared/service/params/param';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-param-general',
  standalone: false,
  templateUrl: './param-general.component.html',
  styleUrl: './param-general.component.scss'
})
export class ParamGeneralComponent {
  commune: any;
  isSubmitted: boolean = false;
  fileName: string = '';
  image: any;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  constructor(
    private operationService: OperationService,
    private paramService: ParameterService,
    private loader: NgxUiLoaderService,
    private messageService: MessageService,

  ) { }
  telephone = '';
  email = '';
  ville = '';

  linkedin_link = '';
  facebook_link = ''; 
  youtube_link = '';


  configMairie: any = {};

  logo: any;
  ngOnInit() {

    this.getLogoNomCommune();
  }
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.image = file;
      this.isSubmitted = true;

    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    (event.currentTarget as HTMLElement).classList.remove('drag-over');
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    (event.currentTarget as HTMLElement).classList.remove('drag-over');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.fileName = files[0].name;
      this.image = files[0];
      this.isSubmitted = true;

    }
  }


  triggerFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
      this.fileInput.nativeElement.click();
    }
  }
  saveCommune() {
    // if (!this.commune) {
    //   this.messageService.add({ severity: 'info', summary: '', detail: "Veuillez entrer un nom de commune" });
    //   return
    // }

    let formData = new FormData();

    formData.append('commune', this.commune)
    formData.append('logo', this.image),
    formData.append('facebook_link', this.facebook_link),
    formData.append('linkedin_link', this.linkedin_link),
    formData.append('youtube_link', this.youtube_link)
    formData.append('email', this.email)
    formData.append('contact', this.telephone)
 
    const requestData = {
      commune: this.commune
    }
    this.loader.start();
    this.operationService.saveParametreGeneral(formData).subscribe(
      (response: any) => {
        this.messageService.add({ severity: 'success', summary: '', detail: response.message });
        this.commune = "",
          this.image = "",
          this.loader.stop();

      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: '', detail: error.error.message });
        this.loader.stop();

      }
    )

  }







  getLogoNomCommune() {

    this.paramService.getParamatrageCommune().subscribe(
      (response: any) => {
        this.configMairie = response.data
        this.logo = this.configMairie?.logo?.value;
        this.commune = this.configMairie?.commune?.value;
        //      console.log("le logo du webservice", response.data);

      },
      (error: any) => {
        //  console.log("une erreur est survenu", error);

      }
    )
  }
}
